export default {
  'messageBox.tab.title.message': 'Message',
  'messageBox.tab.title.notice': 'Notice',
  'messageBox.tab.title.todo': 'Todo',
  'messageBox.tab.button': 'empty',
  'messageBox.allRead': 'All Read',
  'messageBox.viewMore': 'View More',
  'messageBox.noContent': 'No Content',
  'messageBox.switchRoles': 'Switch Roles',
  'messageBox.userCenter': 'User Center',
  'messageBox.userSettings': 'User Settings',
  'messageBox.logout': 'Logout',
};
